// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1Bzmp","list":"PatternAutocomplete_list__1tZmz"};